import './App.css';
import watershed from "./images/watershed-cover.jpg";
import Iframe from 'react-iframe';
import { Card, LightItalicText, HeavyItalicText, ExtraLargeFont, LargeFont, CopyCard } from './Style';
import clearcut from "./images/clear-cut-1.jpg";
import polaroid from "./images/ben-kamen-small.jpg"

function WatershedPressKit() {
    return (
        <div style={{ paddingBottom: '4rem' }}>
            <Card style={{ marginTop: '2rem' }}>
                <img src={watershed} alt="ben kamen - watershed album artwork" width="100%" />
            </Card>

            <Card style={{ marginTop: '1.5rem', background: 'transparent', border: 'none' }}>
                <ExtraLargeFont>
                    <HeavyItalicText>WATERSHED</HeavyItalicText>
                </ExtraLargeFont>
                <LargeFont>
                    <LightItalicText>
                        An album by <HeavyItalicText>Ben Kamen</HeavyItalicText>
                    </LightItalicText>
                </LargeFont>
                <LightItalicText style={{ marginTop: '0.5rem' }}>
                    Released July 15, 2022
                </LightItalicText>
            </Card>

            <CopyCard style={{ marginTop: '1.5rem' }}>
                <LightItalicText>by <a href="https://twitter.com/sophiefkemp">Sophie Kemp</a></LightItalicText>
                <br /><br />
                Over the past two decades, Ben Kamen has created music for a variety of formats and genres — from chamber music to multi-channel sound installations to folk and post-rock. Originally from Ohio, Kamen has lived in Olympia, WA since 2006, where he teaches electronic music composition at The Evergreen State College and develops musical instrument apps, including the drum machine "Patterning."
                <br /><br />
                After a decade-plus of time away from writing and performing his own songs, Kamen started writing again during the early part of the pandemic. Eager for a new sound palette to work with, Kamen took up the alto saxophone and the banjo, two instruments he approached with a beginner's mindset and willingness to push outside of their idiomatic uses through studio experimentation.
                <br /><br />
                <LightItalicText>Keep reading below...</LightItalicText>
            </CopyCard>

            <Card style={{ marginTop: '2rem' }}>
                <Iframe
                    src='https://bandcamp.com/EmbeddedPlayer/album=595682112/size=large/bgcol=0d0d0d/linkcol=5fb4c9/artwork=small/transparent=true/tracklist=true/tracks=555982799,356228300,2007053731,23453315,2057074069,274064508,473220334,2889852013,12820871/'
                    width="100%"
                    height="320px"
                    frameBorder={0}
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                />
            </Card>

            <Card style={{ marginTop: '1.5rem' }}>
                <LightItalicText style={{ marginBottom: '1rem' }}>Purple Shadows</LightItalicText>
                <Iframe
                    src='https://www.youtube.com/embed/HlUSTDT01Cw'
                    width="100%"
                    height="280px"
                    frameBorder={0}
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                />
            </Card>

            <Card style={{ marginTop: '1.5rem' }}>
                <LightItalicText style={{ marginBottom: '1rem' }}>Make Believe</LightItalicText>
                <Iframe
                    src='https://www.youtube.com/embed/kQr6N2O_RBA'
                    width="100%"
                    height="280px"
                    frameBorder={0}
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                />
            </Card>

            <Card style={{ marginTop: '2rem', background: 'transparent', border: 'none' }}>
                <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <a href="https://www.dropbox.com/sh/3sa3i5dk2v10pag/AAC_jVN3ex76PsUw0hUs81rta?dl=0">MP3 Download</a>
                    <a href="https://www.dropbox.com/sh/zppclz1acuuubd8/AADOwWznkfHJkPOEbwymZfyya?dl=0">Photos & Artwork</a>
                    <a href="https://aemail.com/8q1j">Contact</a>
                </div>
            </Card>

            <CopyCard style={{ marginTop: '2rem' }}>
                <img src={polaroid} alt="ben kamen - polaroid" width="100%" />
                <br /><br />
                It took over two years for the explorations to coalesce into an album. Part of that had to do with health issues—Kamen started losing his voice, and a doctor confirmed that he had a paralyzed vocal cord. "There is a lot of grief involved in receiving the news that the thing you've been putting off doing for the last decade might be unattainable. I suppose the flip side of that grief was the resolution that if I gave up, I would be giving up permanently." On Watershed, Kamen learned how to sing again.
                <br /><br />
                What transpired is a record of lush songs with Kamen's voice an instrument as important as a synthesizer or a guitar. The saxophone became an oscillator, treated like a module in a synthesizer that could be layered and processed into a texture. He strummed the banjo through delays and reverbs to create haunted chords.
                <br /><br />
                Look no further to see the results of these experiments with timbre than "Make Believe," the first song to be written for the record. The song has a heavy, repetitive bass-line in an odd-meter, and Kamen takes the saxophone, pitch-shifts it down to double the bass, giving the song a dense, mossy texture, while electric guitar and saxophone layers harmonize in an ominous melody.
                <br /><br />
                "Throughout the writing of the songs that would become Watershed, I was taking daily walks through a trail near my house that winds through a temperate rainforest, full of old growth trees, ferns, and communities of fungus." The record's thematic imagery were strongly informed by this environment. Watershed became a record that negotiates with the death and decay and beauty that exists within nature and in human life.
            </CopyCard>

            <Card style={{ marginTop: '2rem' }}>
                <img src={clearcut} alt="clear cut forest" width="100%" />
            </Card>

            <CopyCard style={{ marginTop: '2rem' }}>
                Watershed is also a study in memory, how we hold on to the past, how we let it go. Music, after all, is a memory device, a collage of fixed moments in time. During the final stages of making the record Kamen participated in a songwriting workshop with Fleet Foxes' Robin Pecknold. One of the first slides in his lecture read "certainty is necessary, but always temporary." That state of mind laid the groundwork for Watershed's lovely "Purple Shadows," a song that captures a brief moment in Kamen's relationship with his father, just months before he passed. It's a song that grapples with memory in its most explicit form.
                <br /><br />
                Kamen performed, recorded and mixed the record himself at home, enlisting Josh Bonati (Sufjan Stevens, Jenny Hval, Amen Dunes) as a mastering engineer.
            </CopyCard>
        </div>
    );
}

export default WatershedPressKit;
